import React, { Component } from 'react';
import { Dimmer, Dropdown as SemanticDropdown, Grid, Loader } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { each, isNil } from 'lodash';
import {
  getActiveProject,
  invalidateActiveProject
} from '../../projects/scenes/singleProject/data/projectActions';
import { ANALYSIS_DATA_ANALYSIS_SECTION, setActiveAnalysisSection } from '../data/actions';
import LayersBox from '../components/analysis/LayersBox';
import HeatMapParameters from '../components/analysis/parameters/HeatMapParameters';
import DataExportationParameters from '../components/analysis/parameters/DataExportationParameters';
import VideoParameters from '../components/analysis/parameters/VideoParameters';
import Visualisations from '../components/analysis/Visualisations';
import {
  removeActiveListeners,
  resetProjectAnalysis,
  setAnalysisModes,
  setProjectContextListener
} from '../data/analysis/actions';
import { fetchProjectAnalysisLayers } from '../data/analysis/layersDispatchers';
import {
  fetchProjectAnalysisGroupParticipations,
  fetchProjectAnalysisParticipations
} from '../data/analysis/participationsActions';
import { resetAllAnalysisData } from '../data/analysis/analysisDataActions';

class Analysis extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasProject: false,
      modeValue: this.getModeValue(),
      analysisModes: this.getAnalysisModes()
    };

    this.setAnalysisModes = this.setAnalysisModes.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    // We got the project, fetch the rest.
    if (nextProps.project !== null && !prevState.hasProject) {
      nextProps.dispatch(fetchProjectAnalysisLayers(nextProps.project.id));
      nextProps.dispatch(fetchProjectAnalysisGroupParticipations(nextProps.project.id));
      nextProps.dispatch(fetchProjectAnalysisParticipations(nextProps.project.id));

      nextProps.dispatch(setProjectContextListener());
      return {
        hasProject: true
      };
    }

    return null;
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(getActiveProject(match.params.id));
    dispatch(setActiveAnalysisSection(ANALYSIS_DATA_ANALYSIS_SECTION));
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(removeActiveListeners());
    dispatch(invalidateActiveProject());
    dispatch(resetProjectAnalysis());
    dispatch(resetAllAnalysisData());
  }

  setAnalysisModes(value) {
    const { analysisModes, dispatch } = this.props;
    const modes = analysisModes.map(analysisMode => {
      analysisMode.selected = analysisMode.id === value;
      return analysisMode;
    });

    dispatch(setAnalysisModes(modes));

    this.setState({
      modeValue: this.getModeValue()
    });
  }

  getModeValue() {
    let modeValue = '';
    each(this.props.analysisModes, mode => {
      if (mode.selected) {
        modeValue = mode.id;
      }
    });
    return modeValue;
  }

  getAnalysisModes() {
    return this.props.analysisModes.map(analysisMode => {
      return {
        key: analysisMode.id,
        text: analysisMode.label,
        value: analysisMode.id,
        selected: analysisMode.selected
      };
    });
  }

  render() {
    let dimmerActive = false;
    let dimmerMessage = 'Initializing';
    if (this.props.isProcessing || isNil(this.props.project)) {
      dimmerActive = true;
    }

    if (this.props.processingStep !== null) {
      dimmerMessage = this.props.processingStep;
    }

    const analysisModeForm = (
      <SemanticDropdown
        selection
        scrolling
        fluid
        disabled={false}
        upward={false}
        onChange={(event, data) => {
          // onChange(data.value);
          this.setAnalysisModes(data.value);
        }}
        onBlur={(event, data) => {
          // onBlur(data.value)
        }}
        onFocus={(event, data) => {
          // onFocus(data.value)
        }}
        value={this.state.modeValue}
        id={1}
        error={false}
        options={this.state.analysisModes}
        placeholder="Choose a mode"
      />
    );
    // {error && <SemanticLabel floating icon="warning sign" color='red'/>}
    let blockParameters;

    switch (this.state.modeValue) {
      // case 'heatMap':
      //   blockParameters = <HeatMapParameters />;
      //   break;
      case 'dataExportation':
        blockParameters = <DataExportationParameters />;
        break;
      // case 'video':
      //   blockParameters = <VideoParameters/>;
      //   break;
      default:
        blockParameters = null;
    }

    return (
      <Dimmer.Dimmable>
        <Dimmer active={dimmerActive} inverted>
          <Loader className="processingDimmer" size="huge">
            {dimmerMessage}
          </Loader>
        </Dimmer>
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <h1>Analysis ({this.props.project ? this.props.project.name : null})</h1>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Grid>
                <Grid.Row className="analysisMode">
                  <Grid.Column>
                    <Grid>
                      <Grid.Row className="columnHeader">
                        <Grid.Column width={2}>
                          <Grid.Row>Choose a mode :</Grid.Row>
                        </Grid.Column>
                        <Grid.Column width={14}>
                          <Grid.Row>{analysisModeForm}</Grid.Row>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={7} className="analysisConfiguration">
                    <Grid>
                      <Grid.Row>
                        <Grid.Column width={8} className="analysisLayers">
                          {/* <Grid.Row className="columnHeader">Layers</Grid.Row> */}
                          {/* <LayersBox /> */}
                        </Grid.Column>
                        <Grid.Column width={8} className="analysisLayerConfiguration">
                          {/* <Grid.Row className="columnHeader">Visualisation Parameters</Grid.Row> */}
                          {/* {blockParameters} */}
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  </Grid.Column>
                  <Visualisations />
                </Grid.Row>
              </Grid>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Dimmer.Dimmable>
    );
  }
}

export default connect(state => ({
  project: state.projects.single.active,
  activeProjectSection: state.projects.single.section,
  processingStep: state.analysis.single.processingStep,
  isProcessing: state.analysis.single.isProcessing,
  analysisModes: state.analysis.single.analysisModes
}))(Analysis);



// WEBPACK FOOTER //
// ./src/scenes/analysis/containers/Analysis.js